import React from 'react';
import 'twin.macro';

import { Link } from 'gatsby';

import { Heading, Subtitle, Button } from '../atoms';
import SanityImage from '../global/SanityImage';

const NewsItem = ({ post }) => {
  if (!post) return null;
  return (
    <div tw="rounded overflow-hidden flex flex-col">
      {post.featuredImage && (
        <SanityImage
          fluid={post.featuredImage.asset.gatsbyImageData}
          tw="w-full"
          alt={post.title}
        />
      )}
      <div>
        <Heading variant="base">{post.title}</Heading>
        <div tw="border my-6 border-black" /> {/* // bottom line */}
        <Subtitle>{post.articleSubtitle}</Subtitle>
      </div>
      <Link to={`/news/${post.slug.current}`} tw="pb-6 mt-auto">
        <Button width="fullWidth">READ MORE</Button>
      </Link>
    </div>
  );
};

export default NewsItem;
